(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["barsana-ghee-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.BarsanaGheeTabs) return;

  function init(root) {
    if (!root || root.getAttribute('data-bgt-ready')) return;
    root.setAttribute('data-bgt-ready', '1');

    var list = root.querySelector('.bgt__tabs');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('.bgt-tab'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.bgt-panel'));
    var toast = root.querySelector('.bgt-toast');
    var toastText = toast ? toast.querySelector('[data-bgt-toast-text]') : null;
    var toastLink = toast ? toast.querySelector('[data-bgt-toast-link]') : null;
    var demo = root.hasAttribute('data-bgt-demo');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var toastTimer;

    function select(index, focus) {
      tabs.forEach(function (tab, n) {
        var on = n === index;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        if (panels[n]) panels[n].hidden = !on;
      });
      var t = tabs[index];
      if (list && t && list.scrollWidth > list.clientWidth + 2) {
        list.scrollTo({
          left: t.offsetLeft - (list.clientWidth - t.offsetWidth) / 2,
          behavior: reduce ? 'auto' : 'smooth'
        });
      }
      if (focus && t) t.focus();
    }

    tabs.forEach(function (tab, n) {
      tab.addEventListener('click', function () { select(n, false); });
      tab.addEventListener('keydown', function (e) {
        var next = -1;
        if (e.key === 'ArrowRight') next = (n + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') next = (n - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = tabs.length - 1;
        if (next > -1) { e.preventDefault(); select(next, true); }
      });
    });

    function showToast(message, withLink) {
      if (!toast || !toastText) return;
      toastText.textContent = message;
      if (toastLink) toastLink.hidden = !withLink;
      toast.classList.add('is-on');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toast.classList.remove('is-on'); }, 4500);
    }

    if (demo && toastLink) {
      toastLink.addEventListener('click', function (e) { e.preventDefault(); });
    }

    function markAdded(btn, original, title) {
      btn.textContent = 'Added ✓';
      btn.classList.add('is-added');
      showToast(title + ' added to cart', true);
      setTimeout(function () {
        btn.disabled = false;
        btn.textContent = original;
        btn.classList.remove('is-added');
      }, 2200);
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-bgt-add]') : null;
      if (!btn || btn.disabled) return;
      var original = btn.textContent;
      var title = btn.getAttribute('data-title') || 'Item';
      btn.disabled = true;
      btn.textContent = 'Adding…';

      if (demo) {
        setTimeout(function () { markAdded(btn, original, title); }, 400);
        return;
      }

      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: Number(btn.getAttribute('data-variant')), quantity: 1 })
      })
        .then(function (res) { if (!res.ok) throw new Error('add failed'); return res.json(); })
        .then(function () { markAdded(btn, original, title); })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = original;
          showToast('Could not add to cart. Please try again.', false);
        });
    });
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-bgt]'), init);
    if (scope && scope.hasAttribute && scope.hasAttribute('data-bgt')) init(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  window.BarsanaGheeTabs = { init: init };
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
